import { render, staticRenderFns } from "./formularioGeneral.vue?vue&type=template&id=3345f176&scoped=true"
import script from "./formularioGeneral.vue?vue&type=script&lang=js"
export * from "./formularioGeneral.vue?vue&type=script&lang=js"
import style0 from "./formularioGeneral.vue?vue&type=style&index=0&id=3345f176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345f176",
  null
  
)

export default component.exports